import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../Translations';

function SectionPlaceholder() {
  return (
    <div
      className={clsx(
        'flex flex-col pt-20 pb-16 items-center justify-center',
        'border border-gray-300 bg-gray-50 rounded-b-md mb-2',
      )}
    >
      <div className="font-bold text-gray-500 text-lg">
        <T kind="[Your Section Goes Here]" />
      </div>
      <div className="text-gray-500">
        <T kind="Add a section to start adding programs." />
      </div>
    </div>
  );
}

export default observer(SectionPlaceholder);
